import React,{useState,useEffect,useRef} from 'react'
import Swal from 'sweetalert2'
import { Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin,ToolbarSlot } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail'
// Import the main component
import { LoadError, Viewer } from '@react-pdf-viewer/core'
// Import the styles
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import '@react-pdf-viewer/core/lib/styles/index.css'

import SampleFile from '../../assets/sample.pdf'

const saveStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: 'rgb(151 150 150)'
}

const PrintSignalBridge = ({ printSignal, onPrint }) => {
  const previousSignalRef = useRef(0)

  useEffect(() => {
    if (!printSignal || printSignal === previousSignalRef.current) return

    previousSignalRef.current = printSignal
    onPrint()
  }, [printSignal, onPrint])

  return null
}

const PrintSignalControl = ({ Print, printSignal }) => {
  if (!printSignal) return null

  return (
    <Print>
      {({ onClick }) => (
        <PrintSignalBridge printSignal={printSignal} onPrint={onClick} />
      )}
    </Print>
  )
}

const PreviewFile = ({ fileUrl,onDownloadClick=()=>{},onPrintClick=()=>{},onSaveClick=null,heightPadding='350px',printSignal=0 }) => {
  const thumbnailPluginInstance = thumbnailPlugin()
  const [pdfFile, setPdfFile] = useState(null);
  //const defaultLayoutPluginInstance = defaultLayoutPlugin()
  const { Thumbnails } = thumbnailPluginInstance

  console.log('fileUrl ', fileUrl)

  useEffect(() => {
    const controller = new AbortController();
    let isActive = true;
    let objectUrl = null;

    setPdfFile(null);

    const fetchPDF = async () => {
      try {
        const response = await fetch(fileUrl, {
          method: 'GET',
          credentials: 'include', // to send cookies with the request
          signal: controller.signal,
          headers: {
            // Add any other headers here
          },
        });
        if (!response.ok) {
          throw new Error(`Failed to load PDF (${response.status})`);
        }
        const blob = await response.blob();
        if (!isActive) return;

        // Create a local URL which points to the blob object
        objectUrl = URL.createObjectURL(blob);
        setPdfFile(objectUrl);
      } catch (error) {
        if (!isActive || error?.name === 'AbortError') return;

        console.error('Error loading PDF:', error);
        Swal.fire('Error', 'ไม่สามารถโหลดไฟล์ PDF ได้ กรุณาลองใหม่อีกครั้ง', 'error');
      }
    };

    if (fileUrl) fetchPDF();
    // Don't forget to revoke the blob URL to avoid memory leaks
    return () => {
      isActive = false;
      controller.abort();
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [fileUrl]);

  const onOpenTabClick = ()=>{
    window.open(pdfFile, '_blank');
  }

  const isTabletOrIpad = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // iPad's user agent string includes "iPad" or "Macintosh" with "Touch" in modern versions
    // due to the desktop-class browsing feature introduced in iPadOS 13.
    const isIpad = /iPad|Macintosh/.test(userAgent) && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  
    // For Android tablets, it's trickier as the user agent does not explicitly say "Tablet",
    // but we can infer it's a tablet if it's not a mobile. This might not be 100% accurate.
    const isAndroidTablet = /Android/.test(userAgent) && !/Mobile/.test(userAgent);
  
    return isIpad || isAndroidTablet;
  };
  


  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {slots => {
          // Destructure all the necessary toolbar items
          const {
            CurrentPageInput,
            Download,
            EnterFullScreen,
            GoToNextPage,
            GoToPreviousPage,
            NumberOfPages,
            Print,
            Zoom,
            ZoomIn,
            ZoomOut,
            SwitchTheme
            // You can include other toolbar items you need here
          } = slots;

          return (
            <>
                <div className='rpv-toolbar__left'>
                {GoToPreviousPage()}
                {CurrentPageInput()} of {NumberOfPages()}
                {GoToNextPage()}
              </div>
              {/* Center items (Zoom controls) */}
              <div className='rpv-toolbar__center'>
                {ZoomOut()}
                {Zoom()}
                {ZoomIn()}
              </div>

              {/* Right side items */}
              <div className='rpv-toolbar__right'>    
                {SwitchTheme()}   
                <PrintSignalControl Print={Print} printSignal={printSignal} />
                {/* Your custom button */}
                {onSaveClick && (
                <button onClick={() => {console.log('Your custom action');onSaveClick()}} className="rpv-core__toolbar-button" style={saveStyle}>
                    <i className="fas fa-save"></i>
                </button>)}
                <button onClick={() => {console.log('Your custom action');onOpenTabClick()}} className="rpv-core__toolbar-button" style={saveStyle}>
                    <i className="fas fa-external-link-alt"></i>
                </button>
                <div style={{ padding: '0px 2px' }} onClick={() => {console.log('Download button clicked');onDownloadClick();}}>
                  {Download()}
                </div>
                <div style={{ padding: '0px 2px' }} onClick={() => {console.log('Print button clicked');onPrintClick();onOpenTabClick();}}>
                  {isTabletOrIpad()?()=>{}:Print()}
                </div>
              </div>
              {/* Add other default toolbar items as needed */}
            </>
          );
        }}
      </Toolbar>
    ),
  });

  let height = '100vh'
  if(heightPadding!=''){
    height = `calc(100vh - ${heightPadding})`
  }

  return (
    <Worker workerUrl="/his/libs/pdfjs/2.10.377/pdf.worker.min.js">
      <div className="mt4" style={{ height: height}}>
        <div
          style={{
            border: '1px solid rgba(0, 0, 0, 0.3)',
            height: '100%',
          }}
        >
          {pdfFile && (<Viewer
            fileUrl={pdfFile}
            defaultScale={1}
            plugins={[defaultLayoutPluginInstance, thumbnailPluginInstance]}
          />)}
        </div>
      </div>
    </Worker>
  )
}

export default PreviewFile
